import type { FC } from 'react'

import styled from '@emotion/styled'

import AuthorCardBase, * as AuthorCard from '@segment/matcha/recipes/AuthorCard'

import contentfulImageLoader from '@segment/utils/contentfulImageLoader/contentfulImageLoader'

interface Author {
  name: string
  avatar: string
  width: number
  height: number
}

export interface AuthorsBoxProps {
  authors: Author[]
}

const AuthorsBox: FC<AuthorsBoxProps> = ({ authors }) => {
  return (
    <>
      {authors.map(({ name, avatar, width, height }, key) => (
        <AuthorCardBase variant="transparent" key={key}>
          <AuthorAvatarsWrapper>
            <StyledAuthorAvatar loader={contentfulImageLoader} src={avatar} width={width} height={height} alt={name} />
          </AuthorAvatarsWrapper>
          <AuthorCard.Body>
            <AuthorCard.Name>Made by {name}</AuthorCard.Name>
          </AuthorCard.Body>
        </AuthorCardBase>
      ))}
    </>
  )
}

const AuthorAvatarsWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
`

const StyledAuthorAvatar = styled(AuthorCard.Avatar)`
  width: 40px;
  height: 40px;
`

export default AuthorsBox
